/**
 * 退票挽留，渠道重置功能
 * 1、初始化设置默认渠道（HttpClient实例过程）
 * 2、监听 /EMP/userinfo 接口设置默认渠道
 * 3、判断URL存在channel参数
 * 3.1、存在，当前更新请求地址附加channel参数和缓存
 * 3.2、不存在，读取判断缓存
 */
import { parse, stringify, parseUrl } from 'query-string';
import parsePath from '../utils/parsePath';
export var channelKey = 'emp_channel';
export function isYXPT(channel) {
    channel = channel || JSON.parse(window.sessionStorage.getItem(channelKey)).use_channel;
    return /(YXPT|JFBGZF)/.test(typeof channel === 'string' ? channel.toLocaleUpperCase() : '');
}
export function setChannleInUserInfoApi(response) {
    if (response === void 0) {
        response = { config: config };
    }
    if (!this._config.channel) {
        return response;
    }
    if (response.config && response.config.url.indexOf('/EMP/userinfo') !== -1) {
        if (!this._base.default_channel) {
            this._base.default_channel = response.data.data.channel;
            window.sessionStorage.setItem(channelKey, JSON.stringify(this._base));
        }
    }
}
function resetUrl(config, channel) {
    var _url = parseUrl(config.url);
    _url.query.channel = channel;
    config.url = _url.url + '?' + stringify(_url.query);
    return config;
}
function updateUseChannel(channel) {
    this._base.use_channel = channel;
    window.sessionStorage.setItem(channelKey, JSON.stringify(this._base));
}
function getUrlParams(url) {
    return parse(parsePath(url || window.location.href).search);
}
function includeRoutes() {
    return (this._config.channelRoutes.filter(function (route) { return window.location.href.indexOf(route) !== -1; })
        .length > 0);
}
function queryChannelTabel(ticketNo, orderNo) {
    var _this = this;
    var bool = includeRoutes.call(this);
    return Object.keys(this._base.channel_table)
        .filter(function (key) {
        return (bool &&
            (_this._base.channel_table[key].ticketNo === ticketNo ||
                _this._base.channel_table[key].orderNo === orderNo));
    })
        .pop();
}
export function channelControl(config) {
    if (!this._config.channel || config.url.indexOf('/EMP') === -1) {
        return config;
    }
    var requestParams = getUrlParams(config.url);
    if (requestParams.channel) {
        updateUseChannel.call(this, requestParams.channel);
        return config;
    }
    var _a = getUrlParams(), channel = _a.channel, ticketNo = _a.ticketNo, orderNo = _a.orderNo;
    if (channel && this._base.use_channel !== channel) {
        // 存储渠道
        this._base.channel_table[new Date().getTime()] = {
            channel: channel,
            ticketNo: ticketNo,
            orderNo: orderNo,
        };
        // 更新当前使用的渠道
        updateUseChannel.call(this, channel);
        // url 带渠道，重置渠道
        return resetUrl(config, channel);
    }
    if (!channel &&
        !queryChannelTabel.call(this, ticketNo, orderNo) &&
        this._base.use_channel !== this._base.default_channel) {
        updateUseChannel.call(this, this._base.default_channel);
        return resetUrl(config, this._base.default_channel);
    }
    return config;
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/request/channelControl.js
// module id = null
// module chunks = 